// Modal responsável por cadastrar uma nova pessoa/entidade no sistema.

import React from "react";
import axios from "axios";

const NovaEntidadeModal = ({
    idProcess,
    token,
    valueCel,
    setValueCel,
    handleInputChangeCel,
    valueCpf,
    setValueCpf,
    handleInputChangeCpf,
}) => {
    function cadastrarPessoa() {
        const nome = document.querySelector("#nome").value;
        const telefone = document.querySelector("#telefone").value;
        const cpf_cnpj = document.querySelector("#cpf_cnpj").value;

        axios
            .post(
                `/api/new/partner/${idProcess}`,
                { token, nome, telefone, cpf_cnpj },
                {
                    withCredentials: true,
                }
            )
            .then((resp) => {
                if (resp.data == 400) {
                    alert("Essa pessoa/cpf já está cadastrado!");
                }
                if (resp.data == 404) {
                    window.location = `/new/partner/erro`;
                }
                if (resp.data.erros.length === 0) {
                    window.location = `/ci/pagamentos/${idProcess}`;
                } else {
                    for (let i = 0; i < resp.data.erros.length; i++) {
                        let elemento = document.querySelector(
                            `#${resp.data.erros[i].elemento}`
                        );
                        elemento.style.backgroundColor = "#FFC0CB";
                    }
                }
            });
    }

    return (
        <div
            className="modal fade"
            id="novaentidade"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Nova Pessoa
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <label
                            className="required"
                            htmlFor="m-cadastrar-descricaoLbl"
                        >
                            Nome
                        </label>
                        <input id="nome" className="form-control" name="nome" />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-descricaoLbl"
                        >
                            Telefone
                        </label>
                        <input
                            id="telefone"
                            value={valueCel}
                            className="form-control"
                            name="telefone"
                            maxLength={14}
                            onChange={(event) =>
                                handleInputChangeCel(event, setValueCel)
                            }
                        />
                        <label
                            className="required"
                            htmlFor="m-cadastrar-descricaoLbl"
                        >
                            CPF/CNPJ
                        </label>
                        <input
                            id="cpf_cnpj"
                            maxLength={18}
                            className="form-control"
                            name="cpf_cnpj"
                            value={valueCpf}
                            onChange={(event) =>
                                handleInputChangeCpf(event, setValueCpf)
                            }
                        />
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={cadastrarPessoa}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovaEntidadeModal;
